import MaterialsLayoutHeader from "@/components/materials/MaterialsLayoutHeader";
import MaterialImagesPaginator from "@/components/ui/MaterialImagesPaginator";
import PDFReader from "@/components/ui/PDFReader.tsx";
import VideoPlayer from "@/components/ui/VideoPlayer.tsx";
import { MaterialsType } from "@/types";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const BASE_URL = import.meta.env.EDS_BASE_URL;

interface MaterialProps {
  tk: string;
  name: string;
  type: string;
  subtype: string;
  images?: string[] | null;
  fileType: string;
  lessonOf: string;
  resource?: string;
}

const MaterialFile = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { fileType, tk, name, type, subtype, resource, images } =
    location.state as MaterialProps;

  const [pdfDetails, setPdfDetails] = useState({
    maxPages: 1,
    currentPage: 1,
  });

  if (!fileType) navigate(-1);

  return (
    <div className="flex flex-col flex-1 w-full h-full p-0">
      <MaterialsLayoutHeader
        url={
          fileType === "link"
            ? resource ?? ""
            : BASE_URL + "/v1/video/stream/" + tk
        }
        type={type as MaterialsType}
        title={name}
        subtype={subtype}
        onClose={() => navigate(-1)}
        fileType={fileType}
        pdfDetails={pdfDetails}
        setPdfDetails={setPdfDetails}
      />

      <div className="flex flex-col flex-1 w-full h-full py-4 lg:py-6">
        {fileType === "pdf" && images ? (
          <MaterialImagesPaginator
            images={images}
            pdfDetails={pdfDetails}
            setPdfDetails={setPdfDetails}
          />
        ) : fileType === "pdf" ? (
          <PDFReader
            url={BASE_URL + "/v1/video/stream/" + tk}
            pdfDetails={pdfDetails}
            setPdfDetails={setPdfDetails}
          />
        ) : fileType === "link" ? (
          <PDFReader
            url={resource ?? ""}
            pdfDetails={pdfDetails}
            setPdfDetails={setPdfDetails}
          />
        ) : (
          <VideoPlayer
            type={"video"}
            url={BASE_URL + "/v1/video/stream/" + tk}
          />
        )}
      </div>
    </div>
  );
};

export default MaterialFile;
